import { render, staticRenderFns } from "./ChangeResponsiblyDialog.vue?vue&type=template&id=1238be02"
import script from "./ChangeResponsiblyDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeResponsiblyDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports